import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useLocation } from 'react-router-dom';
import {
  canActOnPage,
  hasAction,
  isPathAllowedForRole,
  GUARD_EXEMPT_PATHS,
} from '../../../utils/permissions';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

const PageGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { permitted_pages, page_permissions, role } = useAuth();
  const location = useLocation();

  // Girişli herkese açık sayfalar (home, profile, tasks vb.) — izin aranmaz
  if (GUARD_EXEMPT_PATHS.has(location.pathname)) {
    return <>{children}</>;
  }

  // Admin-only sayfalar: sayfa izni olsa bile rol admin değilse erişilemez
  let isAllowed = isPathAllowedForRole(location.pathname, role);

  // Yeni model (aksiyon bazlı, joker destekli) + legacy permitted_pages fallback'i
  isAllowed =
    isAllowed && canActOnPage(page_permissions, permitted_pages, location.pathname, 'read');

  // Özel durum: ACC PDF viewer — üst ACC sayfalarından biri izinliyse açılır
  if (!isAllowed && location.pathname === '/design/acc/pdf-viewer') {
    const accPdfParentPermissionPaths = [
      '/design/acc/pdf-viewer',
      '/design/acc/items',
      '/design/acc/projects',
      '/design/acc',
    ];
    isAllowed = accPdfParentPermissionPaths.some(
      p => hasAction(page_permissions, p, 'read') || permitted_pages.includes(p)
    );
  }

  if (!isAllowed) {
    return (
      <div style={{ color: 'orange', textAlign: 'center', marginTop: 40 }}>
        <h2>403 Forbidden</h2>
        <p>Credentials do not allow access to this page</p>
      </div>
    );
  }
  return <>{children}</>;
};

export { ProtectedRoute, PageGuard };
